import React, {useEffect} from 'react';
import css from './Step.module.scss';
import {useLocation} from 'react-router';
import {useScrollService} from '../ScrollService';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const Step: React.FC<{
  title: string;
  isChecked: boolean;
  type: SETUP_STEP_TYPES;
  isBro?: boolean;
}> = ({title, isChecked, type, isBro}) => {
  const location = useLocation();
  let scroller = useScrollService();
  const focused = location.search.includes(type);

  return (
    <div
      className={`${css.step} ${focused ? css.step_focused : ''}`}
      onClick={() => scroller.current.scroll(type)}
    >
      <div className={css.title}>
        {isBro ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0001 15.0625L6.5834 17.1042C6.43062 17.1875 6.28132 17.2222 6.13548 17.2083C5.98965 17.1945 5.86118 17.1458 5.75007 17.0625C5.63895 16.9792 5.55562 16.8646 5.50007 16.7188C5.44451 16.5729 5.43757 16.4236 5.47923 16.2708L6.37507 12.4583L3.35423 9.89584C3.22923 9.78473 3.15284 9.65626 3.12507 9.51043C3.09729 9.36459 3.10423 9.22223 3.1459 9.08334C3.18757 8.94445 3.26395 8.82987 3.37507 8.73959C3.48618 8.64932 3.62507 8.59723 3.79173 8.58334L7.75007 8.22918L9.31256 4.60418C9.38201 4.4514 9.47923 4.33682 9.60423 4.26043C9.72923 4.18404 9.86118 4.14584 10.0001 4.14584C10.139 4.14584 10.2709 4.18404 10.3959 4.26043C10.5209 4.33682 10.6181 4.4514 10.6876 4.60418L12.2501 8.25001L16.2084 8.58334C16.3751 8.59723 16.514 8.65279 16.6251 8.75001C16.7362 8.84723 16.8126 8.96529 16.8542 9.10418C16.8959 9.24307 16.8994 9.38195 16.8646 9.52084C16.8299 9.65973 16.7501 9.78473 16.6251 9.89584L13.6251 12.4583L14.5209 16.2708C14.5626 16.4236 14.5556 16.5729 14.5001 16.7188C14.4445 16.8646 14.3612 16.9792 14.2501 17.0625C14.139 17.1458 14.0105 17.1945 13.8646 17.2083C13.7188 17.2222 13.5695 17.1875 13.4167 17.1042L10.0001 15.0625Z"
              fill={focused ? undefined : 'url(#unfocused_star_gradient)'}
              className={
                isChecked
                  ? css.focused_bro_star_color
                  : focused
                  ? css.focused_bro_star_color
                  : undefined
              }
            />
            <defs>
              <linearGradient
                id="unfocused_star_gradient"
                x1="15.0001"
                y1="2"
                x2="7.50006"
                y2="17"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" />
                <stop offset="1" className={css.unfocused_bro_star_color} />
              </linearGradient>
            </defs>
          </svg>
        ) : isChecked ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.9375 13L13.8958 8.0625L12.8333 7L8.9375 10.875L7.16667 9.125L6.10417 10.1875L8.9375 13ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18Z"
              className={css.checked_circle_color}
            />
            <path
              d="M8.93758 13L13.8959 8.0625L12.8334 7L8.93758 10.875L7.16675 9.125L6.10425 10.1875L8.93758 13Z"
              fill="white"
            />
          </svg>
        ) : (
          <div className={css.tag_container}>
            <div
              className={`${css.tag} ${focused ? css.tag_focused : ''}`}
            ></div>
          </div>
        )}
        <div>{title}</div>
      </div>
    </div>
  );
};
